import React from "react";
import ContableModule from "../Contable";

export default function Ingresos() {
  return <ContableModule view="income" />;
}
